module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADzSURBVDiNjZMxlsMgDES/8N4ruONC9kuH6fJ8IneQg621xWLH2IRkGnhCjEYjgAbcqJMbdWrlSOsy4AEw9MtDUi3PNMg9EDD0/Gaib3GW7kad3KDx+8uVZDdodHe15/hPhcPT0V+iHYGVSMO3j667QWNzKm5UfXsIuLvac84+hcwcWgTLQxJKOnpx8cANGhHsRrbMMm3VWbEYQh5rKgmUWzZqm7nPhDcAVmxeQXheFXQHZmGXWOwrLZYtCBZDv1c7w5BYicss8gpl5Le+qSgrKelAXJwVf2GZZcr9eSDkSuHQ3m7qS3QFh8fi0X+36Qi1H/kHoKZwL/nG6rwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_s.png
// module id = MOWH
// module chunks = 3